import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-scroll";
import { API } from "../api";
import { BlogsSlider } from "../Slider/BlogsSlider";
import CountingText from "./CountingText";
import "./home.css";
import HomeTop2 from "./HomeTop2";
import LineDrow from "./LineDrow";
import Process3rd from "./Process3rd";
import Testimonial from "./Testimonial";

const blogs = [
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
];

const Home = () => {
  const [homeData, setHomeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedStep, setSelectedStep] = useState(null);
  const navigate = useNavigate();

  // Fetch home content from API
  const fetchHomeContent = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API}/api/home-content`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch home content");
      }

      const data = await response.json();

      if (data?.isSuccess && data?.payload) {
        setHomeData(data.payload);

        // Set initial selected step for Why Choose section
        if (data.payload.homeWhyUs?.steps?.length > 0) {
          setSelectedStep(data.payload.homeWhyUs.steps[0]);
        }
      } else {
        throw new Error(data?.message || "Failed to load home content");
      }
    } catch (error) {
      console.error("Error fetching home content:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
    fetchHomeContent();
  }, []);

  // Helper function to get media URL
  const getMediaUrl = (imageData) => {
    if (!imageData) return "";
    if (typeof imageData === "string") {
      if (imageData.startsWith("http://") || imageData.startsWith("https://"))
        return imageData;
      if (imageData.startsWith("/")) return `${API}/api/media/${imageData}`;
    }
    if (typeof imageData === "object" && imageData?.path) {
      if (
        imageData.path.startsWith("http://") ||
        imageData.path.startsWith("https://")
      ) {
        return imageData.path;
      }
      return `${API}/api/media/${imageData.id}`;
    }
    return "";
  };

  // Transform product data to match Process3rd component structure
  const transformProductData = (homeProduct) => {
    if (!homeProduct) return null;

    return {
      topText: homeProduct.topText || "Products",
      titleMain: homeProduct.titleMain || "Designed for Growth,",
      titleHighlight: homeProduct.titleHighlight || "Driven by Insight",
      description: homeProduct.description || "",
      buttonText: homeProduct.button?.label || "Know More",
      buttonLink: homeProduct.button?.link || "/about-us",
      products: Array.isArray(homeProduct.product)
        ? homeProduct.product.map((prod, index) => ({
            id: (index + 1).toString().padStart(2, "0"),
            title: prod.title || `Product ${index + 1}`,
            subtitle: prod.subtitle || "",
            content: Array.isArray(prod.content) ? prod.content : [],
            buttonText: prod.button?.label || "Explore",
            buttonLink: prod.button?.link || "/our-product",
          }))
        : [],
    };
  };

  // Transform offering data
  const transformOfferingData = (homeOffering) => {
    if (!homeOffering) return null;

    return {
      title: homeOffering.title || "Offerings",
      description: homeOffering.description || "",
      items: Array.isArray(homeOffering.items) ? homeOffering.items : [],
    };
  };

  // Transform why choose data
  const transformWhyChooseData = (homeWhyUs) => {
    if (!homeWhyUs) return null;

    return {
      title: homeWhyUs.title || "Why Choose Ladderup?",
      subtitle:
        homeWhyUs.subtitle ||
        "Because true wealth is built with insight, intention, and impact.",
      steps: Array.isArray(homeWhyUs.steps)
        ? homeWhyUs.steps.map((step) => ({
            ...step,
            path: getMediaUrl(step.path1),
            path2: getMediaUrl(step.path2),
            buttonText: step.button?.label || "Know More",
            buttonLink: step.button?.link || "/about-us",
          }))
        : [],
    };
  };

  // Transform advantage data
  const transformAdvantageData = (homeAdvantage) => {
    if (!homeAdvantage) return null;

    return {
      titleTop: homeAdvantage.titleTop || "The",
      titleMain: homeAdvantage.titleMain || "Ladderup Advantage",
      items: Array.isArray(homeAdvantage.items) ? homeAdvantage.items : [],
    };
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <div className="spinner-border text-orange" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <div className="text-center">
          <h3 className="text-danger">Error Loading Content</h3>
          <p>{error}</p>
          <button className="btn btn-primary mt-3" onClick={fetchHomeContent}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!homeData) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <div className="text-center">
          <h3>No Content Available</h3>
          <p>Please check back later.</p>
        </div>
      </div>
    );
  }

  const productData = transformProductData(homeData.homeProduct);
  const offeringData = transformOfferingData(homeData.homeOffering);
  const whyChooseData = transformWhyChooseData(homeData.homeWhyUs);
  const advantageData = transformAdvantageData(homeData.homeAdvantage);

  return (
    <div>
      {/* Home Top Section */}
      {homeData.homeTop && (
        <HomeTop2
          data={{
            ...homeData.homeTop,
            image: {
              src: getMediaUrl(
                homeData.homeTop.image || homeData.homeTop.imageId
              ),
            },
          }}
        />
      )}

      {/* Products Section */}
      {productData && productData.products.length > 0 && (
        <Process3rd processData={productData} />
      )}

      {/* Offerings Section */}
      {offeringData && <LineDrow data={offeringData} />}

      {/* Why Choose Section */}
      {whyChooseData && whyChooseData.steps.length > 0 && (
        <div className="col-11 m-auto mt-4">
          {/* Section Header */}
          <p className="fs-5 line-height-1" data-aos="fade-up">
            {whyChooseData.title}
          </p>
          <p
            className="fs-1 fw-bold"
            data-aos="fade-up"
            dangerouslySetInnerHTML={{ __html: whyChooseData.subtitle }}
          ></p>

          <div className="row">
            {/* Left Side (Steps Grid) */}
            <div className="col-lg-5">
              <div className="col-11 m-auto row">
                {whyChooseData.steps?.map((step, i) => (
                  <div key={i} className="col-sm-6 mt-4" data-aos="fade-up">
                    <Link
                      to="points"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      style={{ textDecoration: "none" }}
                      onClick={() => setSelectedStep(step)}
                    >
                      <div
                        className="p-3 d-flex align-items-end justify-content-center"
                        style={
                          selectedStep?.title === step?.title
                            ? {
                                background: "#F47024",
                                color: "white",
                                cursor: "pointer",
                                aspectRatio: "1/1",
                              }
                            : {
                                background: "rgba(244,112,36,0.1)",
                                cursor: "pointer",
                                color: "black",
                                aspectRatio: "1/1",
                              }
                        }
                      >
                        <div className="my-3 text-start">
                          <img
                            src={
                              selectedStep?.title === step?.title
                                ? step.path
                                : step.path2
                            }
                            alt={step?.title}
                            loading="lazy"
                            style={{ width: "64px" }}
                            crossOrigin="anonymous"
                          />
                          <p className="fs-5">{step?.title}</p>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Side (Details Panel) */}
            <div className="col-lg-7">
              <div className="text-start points">
                <p className="fs-1 fw-bold mt-3" data-aos="fade-up">
                  {selectedStep?.title}
                </p>
                <p className="fs-5 tJustify" data-aos="fade-up">
                  {selectedStep?.description}
                </p>
                <div className="mt-2 add-ml-20">
                  {selectedStep?.points?.map((point, i) => (
                    <div
                      key={i}
                      className="d-flex gap-2 fs-5 py-2"
                      data-aos="fade-up"
                    >
                      <li>{point}</li>
                    </div>
                  ))}
                </div>
                <button
                  className="buttonEffect mt-2"
                  data-aos="fade-up"
                  onClick={() => navigate(selectedStep?.button.link)}
                >
                  {selectedStep?.button.label}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <br />
      <br />

      {/* Advantage Section */}
      {advantageData && (
        <div className="bg-dark text-white">
          <br />
          <div className="col-11 m-auto ">
            <p className="fs-1" data-aos="fade-up">
              {advantageData.titleTop}
            </p>
            <p className="fs-1 fw-bold" data-aos="fade-up">
              {advantageData.titleMain}
            </p>
            <div className="row mt-3">
              {advantageData.items?.map((el, i) => {
                return (
                  <div
                    key={i}
                    className="col-lg-3 col-6 mt-3 d-flex align-items-center justify-content-center"
                  >
                    <div className="text-center" data-aos="zoom-in">
                      <p className="display-3 fw-semibold text-white d-flex justify-content-center">
                        <span>
                          <CountingText
                            key={el?.num}
                            num={el?.num == null ? 0 : el?.num}
                          />
                        </span>
                        <span>+</span>
                      </p>
                      <p className="fs-5">{el?.title}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <br />
        </div>
      )}

      {/* Testimonial Section */}
      <Testimonial />

      {/* Blog Section */}
      <div className="mt-4">
        <div className="col-11 m-auto text-start ">
          <p className="fs-5" data-aos="fade-up">
            Updates
          </p>
          <p className="fs-1 fw-semibold " data-aos="fade-up">
            The latest from{" "}
          </p>
          <p className="fs-1 fw-bold org line-height-1 mb-2" data-aos="fade-up">
            Ladderup
          </p>
          <div className="d-flex gap-3" data-aos="fade-up"></div>
        </div>
        <div data-aos="fade-up">
          <BlogsSlider data={blogs} />
        </div>
      </div>
    </div>
  );
};

export default Home;
